import React, { Component, Fragment } from "react";
import DataReactTable from "./DataReactTable";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import "moment/locale/es";
import {
  Col,
  Card,
  CardBody,
  Button,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { emphasize, withStyles } from "@material-ui/core/styles";
import history from "../../../../history";
import Spinner from "react-bootstrap/Spinner";
import socketIOClient from "socket.io-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLaptopMedical,
  faCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faUser,
  faNotesMedical,
  faDisease,
  faPlusSquare,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faUserDoctor,
  faCrutch,
  faWheelchair,
  faHeadSideCough,
  faLungs,
  faProcedures,
  faAmbulance,
} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { getSearchClinicHistory } from "./DataFilterClinicHistory";
import ButtonMui from "@material-ui/core/Button";
import ButtonGroupMui from "@material-ui/core/ButtonGroup";

import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import AlergiesListToShow from "../../../Patient/DisplayPatientInformation/components/alergies/components/AlergiesListToShow";
const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#3EA3FC",
      contrastText: "#fff",
    },
    overrides: {
      MuiButton: {
        contained: {
          color: "#fff",
          backgroundColor: "#3EA3FC",
          "&:hover": {
            backgroundColor: "#3EA3FC",
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
              backgroundColor: "#fff",
            },
          },
        },
      },
    },
  },
});

//const ENDPOINT = process.env.REACT_APP_PUBLIC_URL.toString().substring(0, process.env.REACT_APP_PUBLIC_URL.toString().length - 1);
//const socket = socketIOClient(ENDPOINT, { autoConnect: false });

const styles = (theme) => ({
  date: {
    margin: 10,
  },
});

class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      typeOfDocument: "",
      names: "",
      firstLastName: "",
      secondLastName: "",
      date: null,
      datetwo: null,
      admission: "",
      history: "",
      data: [],
      dataTable: [],
      procedimiento: [],
      open: false,
      load: false,
      isLoading: true,
      serviceText: "",
      profile: sessionStorage.getItem("perfil"),
      gamaService: false,
      permits: [],
      indexPage: 0,
      openModalAlergies: false,
      currentPatientInfo: null,
      showSpecialReq: false,
      showFeminineInfo: false,
      showFallingRisks: false,
      askSpecialReq: false,
      askFallingRisk: false,
      showAlergies: false,
      clinic_profile: [],
      clinicNameSpecific: null,
    };
  }

  componentDidMount() {
    //Esteban Londoño Ospina 23/11/2021
    //Funcion que va actualizando la lista de las Admisiones cada vez que se agrega una nueva
    const searchAdmisionSockets = () => {
      if (this.state.dataTable.length <= 0) {
        if (history.location.state !== null) {
          if (typeof history.location.state.estado_list_form !== "undefined") {
            this.setState(
              {
                date:
                  history.location.state.estado_list_form?.fecha_form !== null
                    ? history.location.state.estado_list_form?.fecha_form
                    : null,
                datetwo:
                  history.location.state.estado_list_form?.fecha_form !== null
                    ? history.location.state.estado_list_form?.fecha_form
                    : null,
                serviceText:
                  history.location.state.estado_list_form?.filterService,
                id: history.location.state.estado_list_form?.num_documento,
                indexPage: history.location.state.pageIndex,
              },
              () => {
                if (this.state.id !== null && this.state.id !== undefined) {
                  this.loadIdentity();
                }
              }
            );
          } else {
            if (typeof history.location.state.date !== "undefined") {
              this.setState(
                {
                  date: history.location.state
                    .date /* datetwo: history.location.state.date  */,
                },
                () => console.log("DATEFromLocation", this.state.date)
              );
            } else {
              const hoy = new Date();
              this.setState({ date: moment(hoy) }, () =>
                console.log("DATEFromForm", this.state.date)
              );
            }
          }
        } else {
          const hoy = new Date();
          this.setState({ date: moment(hoy) });
        }

        /* if (history.location.state !== this.state) {
                    //console.log(history.location.state) 
                    this.setState(history.location.state, () => {
                    });
                } else {
                    history.replace({ state: this.state });
                } */
        this.searchHistorial(false, false, false);
      } else {
        this.searchHistorial(true, false, false);
      }
    };
    searchAdmisionSockets();
    this.validatePermissionsListClinicHistory();
    this.validateShowInfoClinic();
    this.loadDataProfile();
    //console.log(socket);
    /*socket.on("updateListAdmisionsConn", function (data) {
            
        });*/
  }

  componentWillUnmount() {
    console.log("Cerrando Modulo de Historias Clinicas");
  }

  handlerTypeOfDocument = (type) => {
    this.setState({ typeOfDocument: type });
  };

  handlerNames = (names) => {
    this.setState({ names: names.toString().toUpperCase() });
  };

  handlerFirstLastName = (name) => {
    this.setState({ firstLastName: name.toString().toUpperCase() });
  };

  handlerSecondLastName = (name) => {
    this.setState({ secondLastName: name.toString().toUpperCase() });
  };

  handlerDate = (date) => {
    if (new Date(date)) {
      this.setState({ date: date, datetwo: null });
    } else {
      this.setState({ date: null });
    }
  };

  handlerHistoryNumber = (history) => {
    this.setState({ history: history });
  };

  handlerDocumentNumber = (id) => {
    this.setState({ id: id }, () => {
      this.loadIdentity();
    });
  };

  handlerServiceText = (service_text) => {
    this.setState({ serviceText: service_text });
  };

  loadServicioPorId = async (id_servicio) => {
    var data = { id_servicio: id_servicio };
    const response = await fetch(
      process.env.REACT_APP_PUBLIC_URL + "servicio/consultar",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      }
    );
    const responseData = await response.json();

    return responseData.contenido[0];
  };

  loadIdentity = () => {
    var data = { num_documento: this.state.id };
    fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          this.setState({
            names: data.contenido[0].nombres,
            firstLastName: data.contenido[0].apellido1,
            secondLastName: data.contenido[0].apellido2,
          });
        } else {
          this.setState({
            names: "",
            firstLastName: "",
            secondLastName: "",
            history: "",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  validateFields = (data) => {
    if (
      (data.id_historia == "" ||
        data.id_historia == null ||
        data.id_historia == undefined ||
        data.id_historia == 0 ||
        data.id_historia == "0") &&
      (data.num_documento == "" ||
        data.num_documento == null ||
        data.num_documento == undefined ||
        data.num_documento == 0 ||
        data.num_documento == "0") &&
      (data.nombres == "" ||
        data.nombres == null ||
        data.nombres == undefined ||
        data.nombres == 0 ||
        data.nombres == "0") &&
      (data.apellido1 == "" ||
        data.apellido1 == null ||
        data.apellido1 == undefined ||
        data.apellido1 == 0 ||
        data.apellido1 == "0") &&
      (data.apellido2 == "" ||
        data.apellido2 == null ||
        data.apellido2 == undefined ||
        data.apellido2 == 0 ||
        data.apellido2 == "0") &&
      (data.fecha_admision == "" ||
        data.fecha_admision == null ||
        data.fecha_admision == undefined ||
        data.fecha_admision == 0 ||
        data.fecha_admision == "0") &&
      (data.tip_documento == "" ||
        data.tip_documento == null ||
        data.tip_documento == undefined ||
        data.tip_documento == 0 ||
        data.tip_documento == "0")
    ) {
      return false;
    } else {
      return true;
    }
  };

  searchHistorial = (efectoTitilante, isClick, profUser) => {
    this.setState({ load: true, isLoading: true }, () => {
      let id_usuario = JSON.parse(sessionStorage.getItem("usuario")).id_usuario;

      let data = {
        id_historia:
          this.state.history !== "" && this.state.history !== null
            ? parseInt(this.state.history)
            : 0,
        num_documento: this.state.id !== "" ? this.state.id : "0",
        nombres: this.state.names !== "" ? this.state.names : "0",
        apellido1:
          this.state.firstLastName !== "" ? this.state.firstLastName : "0",
        apellido2:
          this.state.secondLastName !== "" ? this.state.secondLastName : "0",
        fecha_admision:
          this.state.datetwo !== null
            ? this.state.datetwo
            : this.state.date !== null
            ? moment(this.state.date).format("YYYY-MM-DD")
            : "0",
        tip_documento:
          this.state.typeOfDocument !== null && this.state.typeOfDocument !== ""
            ? this.state.typeOfDocument
            : "",
        servicio_texto: this.state.serviceText,
        id_usuario: profUser ? 0 : id_usuario,
      };

      let infoStateFormListClinicHistory = {
        num_documento: this.state.id !== "" ? this.state.id : "",
        fecha_form:
          this.state.datetwo !== null
            ? this.state.datetwo
            : this.state.date !== null
            ? moment(this.state.date).format("YYYY-MM-DD")
            : null,
        filterService: this.state.serviceText,
        indexPage: this.state.indexPage,
      };

      let validate = this.validateFields(data);

      if (!validate) {
        if (isClick) {
          alert("Se requiere minimo un Parametro para realizar la Busqueda");
        }
        this.setState({ load: false, isLoading: false });
        return;
      }

      getSearchClinicHistory(data, infoStateFormListClinicHistory)
        .then((pacientes) => {
          let newOrder =
            this.organizeHistoryDataListByDateAppointment(pacientes);
          let sortListAcordingToState = pacientes.sort((a, b) => {
            const nameA = a.historia_cerrada;
            const nameB = b.historia_cerrada;
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          this.setState({
            dataTable: sortListAcordingToState,
            data: pacientes,
            load: false,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  organizeHistoryDataListByDateAppointment = (historyList) => {
    const size = historyList.length;
    let j, temp;

    for (let i = 1; i < size; i++) {
      j = i;
      temp = historyList[i];
      while (
        j > 0 &&
        moment(historyList[j - 1].fecha_cita_agenda).isBefore(
          temp.fecha_cita_agenda
        )
      ) {
        historyList[j] = historyList[j - 1];
        j--;
      }
      historyList[j] = temp;
    }
    return historyList;
  };

  handlerPageIndex = (pageIndex) => {
    this.setState({ indexPage: pageIndex });
  };

  validateDiagnosticImages = (dataFiles, id_admision) => {
    if (dataFiles != undefined && dataFiles != null) {
      if (dataFiles.archivos[0] != undefined && dataFiles.archivos[0] != null) {
        if (dataFiles.archivos[0].clase === "8") {
          return true;
        } else {
          return false;
        }
      } else {
        console.log("admisionProblema", id_admision);
        return false;
      }
    } else {
      return false;
    }
  };

  callbackTenCorrect = (id_admision, valueTen) => {
    let dataNew = this.state.dataTable.filter((adm) => adm.id_admision != null);
    let index = dataNew.findIndex((adm) => adm.id_admision == id_admision);
    dataNew[index].correctos = valueTen;
    this.setState({ dataTable: dataNew });
  };

  callbackFallingRisks = (id_admision, valueCaidas) => {
    let dataNew = this.state.dataTable.filter((adm) => adm.id_admision != null);
    let index = dataNew.findIndex((adm) => adm.id_admision == id_admision);
    dataNew[index].riesgo_caidas = valueCaidas;
    this.setState({ dataTable: dataNew });
  };

  callbackRadioPharmacy = (id_admision, valuePharma) => {
    let dataNew = this.state.dataTable.filter((adm) => adm.id_admision != null);
    let index = dataNew.findIndex((adm) => adm.id_admision == id_admision);
    dataNew[index].radiofarmaco_aplicado = valuePharma;
    this.setState({ dataTable: dataNew });
  };

  callbackupdateCanalization = (id_admision, value) => {
    let newData = this.state.dataTable.filter((adm) => adm.id_admision != null);
    let index = newData.findIndex((adm) => adm.id_admision == id_admision);
    newData[index].canalizacion_radiofarmaco = value;
    this.setState({ dataTable: newData });
  };

  callbackupdateStateClinicHistory = (id_admision, value) => {
    let newData = this.state.dataTable.filter((adm) => adm.id_admision != null);
    let index = newData.findIndex((adm) => adm.id_admision == id_admision);
    newData[index].historia_cerrada = value;
    this.setState({ dataTable: newData });
  };

  callbackupdateStatusPatient = (id_admision, value) => {
    let newData = this.state.dataTable.filter((adm) => adm.id_admision != null);
    let index = newData.findIndex((adm) => adm.id_admision == id_admision);
    console.log({
      id_admision,
      value,
      actualstate: newData[index].check_paciente,
    });
    newData[index].check_paciente = value;
    this.setState({ dataTable: newData });
  };

  callbackupdateStatusVitalSigns = (id_admision, value) => {
    let newData = this.state.dataTable.filter((adm) => adm.id_admision != null);
    let index = newData.findIndex((adm) => adm.id_admision == id_admision);
    newData[index].signos_vitales_realizados = value;
    this.setState({ dataTable: newData });
  };

  callbackActivityPatientStudio = (id_admision, value, id_estudio_paciente) => {
    let newData = this.state.dataTable.filter((adm) => adm.id_admision != null);
    let index = newData.findIndex((adm) => adm.id_admision == id_admision);
    newData[index].id_estudio_paciente = id_estudio_paciente;
    newData[index].actividades_realizadas = value;
    this.setState({ dataTable: newData });
  };

  verifyEffectText(data_admision, efectoTitilante) {
    let verifiedEffect = false;
    if (
      moment(this.state.date).format("YYYY-MM-DD") ==
        moment(new Date()).format("YYYY-MM-DD") &&
      this.state.dataTable.length > 0 &&
      efectoTitilante == true
    ) {
      verifiedEffect =
        this.state.dataTable.some(
          (data_adm) => data_adm.id_admision == data_admision.id_admision
        ) == true
          ? false
          : true;
      console.log(verifiedEffect);
    }
    return verifiedEffect;
  }

  verifyGamagrafia = (servicios) => {
    try {
      if (servicios !== undefined && servicios !== null) {
        let existeGamagrafia = servicios.some((ser) => {
          let verifyCups = ser.codigo ?? ser.cupscod;
          return (
            ser.nombre.toUpperCase().search("GAMAGRAFIA") != -1 ||
            verifyCups.substr(0, 3) == "920" ||
            verifyCups.substr(0, 3) == "921"
          ); /* */
        });

        let existeEcografia = servicios.some((ser) => {
          let verifyCups = ser.codigo ?? ser.cupscod;
          return (
            ser.nombre.toUpperCase().includes("ECOGRAFIA") ||
            verifyCups.substr(0, 2) == "88" ||
            verifyCups.substr(0, 2) == "87" ||
            verifyCups.substr(0, 4) === "3130"
          );
        });

        return existeGamagrafia || existeEcografia;

        //this.setState({gamaService: existeGamagrafia || existeEcografia  })
      }
    } catch (error) {
      console.log(error);
    }
  };

  verifyTerapia = async (serv) => {
    const servicios = [];
    for (let i = 0; i < serv.length; i++) {
      const service = await this.loadServicioPorId(serv[i].id_servicio);
      servicios.push(service);
    }

    try {
      if (servicios !== undefined && servicios !== null) {
        return servicios.some((ser) => {
          let verifyAislamiento = ser.ind_hospitalizacion;
          return (
            ser.nombre.toUpperCase().includes("TERAPIA") &&
            verifyAislamiento === true
          );
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  validatePermissionsListClinicHistory = () => {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    if (user != null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil.modulos;
        this.setState({ permits: perfil });
      } else {
        var perfil = [];
        this.setState({ permits: [] });
      }
    } else {
      this.setState({ permits: [] });
    }
  };

  verifyColorStateAdmission = (state) => {
    let stateColor = "#808080";
    if (state === "Abierta") {
      stateColor = "#40F400";
    } else if (state === "Cerrada") {
      stateColor = "#FF0000";
    } else if (state === "Cancelada") {
      stateColor = "#FFFF00";
    } else {
      stateColor = "#808080";
    }
    return stateColor;
  };

  verifyColorStateClinicHistory = (state) => {
    let stateColor = "#808080";
    if (state === false) {
      stateColor = "#40F400";
    } else if (state === true) {
      stateColor = "#FF0000";
    } else {
      stateColor = "#808080";
    }
    return stateColor;
  };

  goToSelectedDate = (date, forward, backward) => {
    let today = moment(new Date());
    let dateToGo = null;
    if (date !== null && date !== undefined) {
      if (backward) {
        dateToGo = moment(date).subtract(1, "day");
        this.setState({ date: dateToGo, datetwo: null, indexPage: 0 }, () => {
          console.log(
            "DAY",
            moment(this.state.date).format("DD-MM-YYYY"),
            "DAYSTATE",
            this.state.date
          );
          //this.searchAdmissions(this.state.stateAdmision, false, true);
          this.searchHistorial(false, true, false);
        });
      } else if (forward) {
        dateToGo = moment(date).add(1, "day");
        this.setState({ date: dateToGo, datetwo: null, indexPage: 0 }, () => {
          console.log(
            "DAY",
            moment(this.state.date).format("DD-MM-YYYY"),
            "DAYSTATE",
            this.state.date
          );
          //this.searchAdmissions(this.state.stateAdmision, false, true);
          this.searchHistorial(false, true, false);
        });
      } else {
        dateToGo = today;
        this.setState({ date: dateToGo, datetwo: null, indexPage: 0 }, () => {
          console.log(
            "DAY",
            moment(this.state.date).format("DD-MM-YYYY"),
            "DAYSTATE",
            this.state.date
          );
          //this.searchAdmissions(this.state.stateAdmision, false, true);
          this.searchHistorial(false, true, false);
        });
      }
    }
  };

  loadDataProfile = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "clinica/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.length > 0) {
          this.verifyClinic(data);
          this.setState({
            clinic_profile: data[0],
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  verifyClinic = (data) => {
    const currentClinic = data[0].nombre;
    const isClinicNameSpecific =
      "UNIDAD DE ESPECIALIDADES MEDICAS SAS" === currentClinic;

    this.setState({ clinicNameSpecific: isClinicNameSpecific });
  };

  goToClinicHistory = async (data) => {
    let validateService = this.verifyGamagrafia(data.servicios);
    console.log("validateService",validateService);
    
    let validateTherapy = await this.verifyTerapia(data.servicios);

    const url = validateTherapy 
      ? "/assitencial/clinic-history2"
      : validateService
      ? //muestra las entrevista
        this.state.clinicNameSpecific
        ? "/assitencial/clinic-history2"
        : "/assitencial/clinic-history3"
      : //muestra los diagnostico
        "/assitencial/clinic-history2";

    history.push({
      pathname: process.env.PUBLIC_URL + url,
      state: { data: data, pageIndex: this.state.indexPage },
    });
  };

  handlerOpenModalAlergies = (event, currentPatient) => {
    this.setState({
      openModalAlergies: event,
      currentPatientInfo: currentPatient,
    });
  };

  validateShowInfoClinic = () => {
    let clinica = JSON.parse(sessionStorage.getItem("clinica"));
    this.setState({
      askSpecialReq: !!clinica
        ? clinica.hasOwnProperty("solicitar_req_especiales")
          ? clinica.solicitar_req_especiales
          : false
        : false,
      askFallingRisk: !!clinica
        ? clinica.hasOwnProperty("solicitar_riesdo_caida")
          ? clinica.solicitar_riesdo_caida
          : false
        : false,
      showAlergies: !!clinica
        ? clinica.hasOwnProperty("ver_alergias_listado_hc_adm")
          ? clinica.ver_alergias_listado_hc_adm
          : false
        : false,
    });
  };

  verifyColorRisk = (caidas) => {
    let colorSelected = "#6F6964";
    if (caidas.riesgo !== "") {
      switch (caidas.riesgo) {
        case "Bajo":
          colorSelected = "#00D51A";
          break;
        case "Alto":
          colorSelected = "#F71C06";
          break;
        case "Medio":
          colorSelected = "#F7EF06";
          break;
        default:
          colorSelected = "#6F6964";
          break;
      }
    } else {
      colorSelected = "#6F6964";
    }
    return colorSelected;
  };

  refreshData = () => {
    this.searchHistorial(false, false, false);
  };

  render() {
    const profile = sessionStorage.getItem("perfil");
    const reactTableData = {
      tableHeaderData: [
        {
          Header: "DOCUMENTO",
          accessor: "num_documento",
          disableGlobalFilter: true,
          width: 65,
          Cell: (row) => (
            <div
              className={`admision-new ${
                row.data[row.row.index].destacar == true
                  ? "effect-admision-new"
                  : null
              }`}
            >
              <div className="info-pacient-migrated">
                <div>
                  <button
                    className={
                      row.row.original.paciente_migrado
                        ? "patient-migrated patient-migrated--new"
                        : "icon-patient"
                    }
                  >
                    <div
                      className={
                        row.row.original.paciente_migrado
                          ? "patient-migrated-new-label"
                          : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faUser}
                        id={
                          row.row.original.paciente_migrado
                            ? "setPatient"
                            : "none"
                        }
                      />
                      <div />
                      {row.row.original.paciente_migrado ? (
                        <UncontrolledTooltip
                          placement="center"
                          target="setPatient"
                        >
                          Paciente migrado desde otro aplicativo
                        </UncontrolledTooltip>
                      ) : null}
                    </div>
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div>
                    {row.row.original.tip_documento}{" "}
                    {row.row.original.num_documento}
                  </div>
                  {row.row.original.paciente_migrado ? (
                    <div>
                      {" "}
                      <label>
                        <b>Migrado</b>
                      </label>{" "}
                    </div>
                  ) : null}
                </div>
              </div>
              {row.row.original.has_alergies && this.state.showAlergies ? (
                <div className="wrap-info">
                  <div className="tooltip-alergies">
                    <Tooltip title="Alergias">
                      <IconButton
                        aria-label="launch"
                        color="inherit"
                        style={{
                          padding: 2,
                          backgroundColor: "#FF5B1D",
                          width: "1em",
                          height: "1em",
                        }}
                        //disabled={this.state.patienteExist || this.props.dataEvent.id_cita !== "" ? false : true}
                        onClick={() => {
                          this.handlerOpenModalAlergies(
                            !this.state.openModalAlergies,
                            row.row.original
                          );
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faDisease}
                          style={{
                            color: "#FFFFFF",
                            width: "0.8em",
                            height: "0.8em",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              ) : null}
            </div>
          ),
        },
        {
          Header: "N°. ADMISIÓN",
          accessor: "id_admision",
          Cell: (row) => (
            <div
              style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "space-around",
                margin: 0,
                padding: 0,
              }}
            >
              <div
                className={`admision-new ${
                  row.data[row.row.index].destacar == true
                    ? "effect-admision-new"
                    : null
                }`}
              >
                {row.value}
              </div>
              {/*
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div><p><b>Estado:</b></p> </div>
                                <div><p><FontAwesomeIcon icon={faCircle} style={{ color: this.verifyColorStateAdmission(row.row.original.estado) }} /> &nbsp;{row.row.original.estado}</p></div>
                            </div>*/}
            </div>
          ),
        },
        {
          Header: "Estado de Historia",
          accessor: "historia_cerrada",
          Cell: (row) => (
            <div
              style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "space-around",
                margin: 0,
                padding: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div>
                  <p>
                    <b>Estado:</b>
                  </p>{" "}
                </div>
                {console.log("DataRow", row.row.original)}
                <div>
                  <p>
                    <FontAwesomeIcon
                      icon={faCircle}
                      style={{
                        color: this.verifyColorStateClinicHistory(row.value),
                      }}
                    />{" "}
                    &nbsp;{row.value == true ? "Cerrada" : "Abierta"}
                  </p>
                </div>
              </div>
            </div>
          ),
        },
        /*  {
                     Header: 'Fecha',
                     accessor: 'fecha',
                     Cell: row => (
                         <span className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                             {row.value}
                         </span>)
                 }, */
        {
          Header: "NOMBRES",
          accessor: "nombres",
          Cell: (row) => (
            <span
              className={`admision-new ${
                row.data[row.row.index].destacar == true
                  ? "effect-admision-new"
                  : null
              }`}
            >
              <label
                style={{
                  cursor: "pointer",
                  color: "#0084CF",
                  textDecoration: "underline",
                }}
                onClick={() => this.goToClinicHistory(row.row.original)}
              >
                {row.value}
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {row.row.original.requerimientos_especiales != undefined &&
                this.state.askSpecialReq ? (
                  <>
                    <div>
                      <p style={{ marginLeft: 3, color: "#1086e0" }}>
                        Req. Especiales:
                      </p>
                    </div>
                    <div
                      className="flex-row"
                      style={{ justifyContent: "center", flex: "wrap" }}
                    >
                      {row.row.original.requerimientos_especiales
                        .hospitalizado != undefined &&
                      row.row.original.requerimientos_especiales
                        .hospitalizado != false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faPlusSquare}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.muletas !=
                        undefined &&
                      row.row.original.requerimientos_especiales.muletas !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faCrutch}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.sillas !=
                        undefined &&
                      row.row.original.requerimientos_especiales.sillas !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faWheelchair}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales
                        .sintomas_respiratorios != undefined &&
                      row.row.original.requerimientos_especiales
                        .sintomas_respiratorios != false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faHeadSideCough}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.oxigeno !=
                        undefined &&
                      row.row.original.requerimientos_especiales.oxigeno !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faLungs}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.camilla !=
                        undefined &&
                      row.row.original.requerimientos_especiales.camilla !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faProcedures}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.ambulancia !=
                        undefined &&
                      row.row.original.requerimientos_especiales.ambulancia !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faAmbulance}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.ninguno !=
                        undefined &&
                      row.row.original.requerimientos_especiales.ninguno !=
                        false &&
                      row.row.original.requerimientos_especiales.otro ==
                        false &&
                      row.row.original.requerimientos_especiales.ambulancia ==
                        false &&
                      row.row.original.requerimientos_especiales.camilla ==
                        false &&
                      row.row.original.requerimientos_especiales.oxigeno ==
                        false &&
                      row.row.original.requerimientos_especiales
                        .sintomas_respiratorios == false &&
                      row.row.original.requerimientos_especiales.sillas ==
                        false &&
                      row.row.original.requerimientos_especiales.muletas ==
                        false &&
                      row.row.original.requerimientos_especiales
                        .hospitalizado == false ? (
                        <div className="element-icon-adm">
                          <span style={{ marginLeft: 3, color: "#1086e0" }}>
                            Ninguno
                          </span>
                        </div>
                      ) : null}
                    </div>
                    {row.row.original.requerimientos_especiales.otro !=
                      undefined &&
                    row.row.original.requerimientos_especiales.otro != false ? (
                      <div className="element-icon-adm">
                        <span style={{ marginLeft: 3, color: "#1086e0" }}>
                          {" "}
                          - {row.row.original.requerimientos_especiales.otroReq}
                        </span>
                      </div>
                    ) : null}
                  </>
                ) : null}
                {this.state.askFallingRisk && (
                  <div
                    className="flex-column "
                    style={{ alignItems: "center" }}
                  >
                    <div>Riesgo de caída: </div>
                    <div>
                      <span>
                        <FontAwesomeIcon
                          icon={faCircle}
                          style={{
                            color: this.verifyColorRisk(
                              row.row.original.riesgo_caidas
                            ),
                          }}
                        />{" "}
                        <b>{row.row.original.riesgo_caidas.riesgo}</b>
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </span>
          ),
        },
        {
          Header: "FECHA CITA",
          accessor: "fecha_cita",
          Cell: (row) => (
            <div
              className="title-list-admission-group"
              style={{ padding: 0, margin: 0 }}
            >
              <div className="title-list-admission">
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {moment(row.row.original.fecha_cita_agenda).format(
                    "DD-MMM-YYYY"
                  )}
                </span>
              </div>
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {moment(row.row.original.fecha_cita_agenda).format(
                    "h:mm:ss a"
                  )}
                </span>
              </div>
            </div>
          ),
        },
        {
          Header: "FECHA INGRESO",
          accessor: "fecha_ingreso_completa",
          Cell: (row) => (
            <div
              className="title-list-admission-group"
              style={{ padding: 0, margin: 0 }}
            >
              <div className="title-list-admission">
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {moment(
                    row.row.original.fecha_ingreso_completa_admision
                  ).format("DD MMM YYYY")}
                </span>
              </div>
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {moment(
                    row.row.original.fecha_ingreso_completa_admision
                  ).format("h:mm:ss a")}
                </span>
              </div>
            </div>
          ),
        },
        {
          Header: "SERVICIOS",
          accessor: "servName",
          Cell: (row) => (
            <div className="cell-info-table-admission">
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {this.state.profile !== "10" ? (
                    row.row.original.profesional != undefined &&
                    row.row.original.profesional != null ? (
                      <b>
                        {" "}
                        Dr(a). {row.row.original.profesional.toUpperCase()}
                        <br />{" "}
                      </b>
                    ) : (
                      ""
                    )
                  ) : null}
                  {row.value}
                </span>
                <hr
                  style={{
                    color: "#55e5bb",
                    backgroundColor: "#55e5bb",
                    margin: "0.25em 0.25em",
                    padding: 0,
                  }}
                ></hr>
              </div>
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  <b>
                    {row.row.original.thirdsName != undefined &&
                    row.row.original.thirdsName != null
                      ? row.row.original.thirdsName
                      : ""}
                  </b>
                </span>
              </div>
            </div>
          ),
        },
      ],
      tableRowsData: this.state.dataTable,
    };

    const reactTableDataProfessional = {
      tableHeaderData: [
        {
          Header: "DOCUMENTO",
          accessor: "num_documento",
          disableGlobalFilter: true,
          width: 65,
          Cell: (row) => (
            <div
              className={`admision-new ${
                row.data[row.row.index].destacar == true
                  ? "effect-admision-new"
                  : null
              }`}
            >
              <div className="info-pacient-migrated">
                <div>
                  <button
                    className={
                      row.row.original.paciente_migrado
                        ? "patient-migrated patient-migrated--new"
                        : "icon-patient"
                    }
                  >
                    <div
                      className={
                        row.row.original.paciente_migrado
                          ? "patient-migrated-new-label"
                          : ""
                      }
                    >
                      <FontAwesomeIcon
                        icon={faUser}
                        id={
                          row.row.original.paciente_migrado
                            ? "setPatient"
                            : "none"
                        }
                      />
                      <div />
                      {row.row.original.paciente_migrado ? (
                        <UncontrolledTooltip
                          placement="center"
                          target="setPatient"
                        >
                          Paciente migrado desde otro aplicativo
                        </UncontrolledTooltip>
                      ) : null}
                    </div>
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div>
                    <label>
                      {row.row.original.tip_documento}{" "}
                      {row.row.original.num_documento}
                    </label>
                  </div>
                  {row.row.original.paciente_migrado ? (
                    <div>
                      {" "}
                      <label>
                        <b>Migrado</b>
                      </label>{" "}
                    </div>
                  ) : null}
                </div>
              </div>
              {row.row.original.has_alergies && this.state.showAlergies ? (
                <div className="wrap-info">
                  <div className="tooltip-alergies">
                    <Tooltip title="Alergias">
                      <IconButton
                        aria-label="launch"
                        color="inherit"
                        style={{
                          padding: 2,
                          backgroundColor: "#FF5B1D",
                          width: "1em",
                          height: "1em",
                        }}
                        //disabled={this.state.patienteExist || this.props.dataEvent.id_cita !== "" ? false : true}
                        onClick={() => {
                          this.handlerOpenModalAlergies(
                            !this.state.openModalAlergies,
                            row.row.original
                          );
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faDisease}
                          style={{
                            color: "#FFFFFF",
                            width: "0.8em",
                            height: "0.8em",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              ) : null}
              {row.row.original.id_estudio_paciente != null &&
              row.row.original.id_estudio_paciente != undefined ? (
                <>
                  <br />
                  <div className="info-pacient-migrated">
                    <div>
                      <button className={"icon-patient"}>
                        <div>
                          <FontAwesomeIcon icon={faNotesMedical} />
                          <div />
                        </div>
                      </button>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <div>
                        <label>
                          <b>ID Paciente</b>{" "}
                          {row.row.original.id_estudio_paciente != null &&
                            row.row.original.id_estudio_paciente}
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          ),
        },
        {
          Header: "N°. ADMISIÓN",
          accessor: "id_admision",
          Cell: (row) => (
            <div
              style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "space-around",
                margin: 0,
                padding: 0,
              }}
            >
              <div
                className={`admision-new ${
                  row.data[row.row.index].destacar == true
                    ? "effect-admision-new"
                    : null
                }`}
              >
                {row.value}
              </div>

              {/*<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div><p><b>Estado:</b></p> </div>
                                <div><p><FontAwesomeIcon icon={faCircle} style={{ color: this.verifyColorStateAdmission(row.row.original.estado) }} /> &nbsp;{row.row.original.estado}</p></div>
                            </div>*/}
            </div>
          ),
        },
        {
          Header: "Estado de Historia",
          accessor: "historia_cerrada",
          Cell: (row) => (
            <div
              style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "space-around",
                margin: 0,
                padding: 0,
              }}
            >
              {this.verifyGamagrafia(row.row.original.servicios) ? (
                <Fragment>
                  <div>
                    <Tooltip title="Abrir Imágenes Diagnósticas">
                      <IconButton
                        aria-label="launch"
                        style={{ padding: 2 }}
                        onClick={() => {
                          const dataImges = row.row.original;
                          history.push({
                            pathname:
                              process.env.PUBLIC_URL + "/assitencial/daicoms",
                            state: {
                              dataImg: dataImges,
                              dataPatient: row.row.original,
                              pageIndex: this.state.indexPage,
                            },
                          });
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faLaptopMedical}
                          style={{ color: "#97A090" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                  {/* <div>
                                        <Tooltip title="Abrir Imágenes Diagnósticasv2">
                                            <IconButton aria-label="launch"
                                                style={{ padding: 2 }}
                                                onClick={() => {
                                                    const dataImges = row.row.original;
                                                    history.push({
                                                        pathname: process.env.PUBLIC_URL + '/assitencial/dicomv2',
                                                        state: {
                                                            dataImg: dataImges,
                                                            dataPatient: row.row.original,
                                                            pageIndex: this.state.indexPage
                                                        }
                                                    });
                                                }}>
                                                <FontAwesomeIcon icon={faLaptopMedical} style={{ color: '#97A090' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div> */}
                </Fragment>
              ) : null}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div>
                  <p>
                    <b>Estado:</b>
                  </p>{" "}
                </div>
                <div>
                  <p>
                    <FontAwesomeIcon
                      icon={faCircle}
                      style={{
                        color: this.verifyColorStateClinicHistory(row.value),
                      }}
                    />{" "}
                    &nbsp;{row.value == true ? "Cerrada" : "Abierta"}
                  </p>
                </div>
              </div>
            </div>
          ),
        },
        {
          Header: "NOMBRES",
          accessor: "nombres",
          Cell: (row) => (
            <span
              className={`admision-new ${
                row.data[row.row.index].destacar == true
                  ? "effect-admision-new"
                  : null
              }`}
            >
              <label
                style={{
                  cursor: "pointer",
                  color: "#0084CF",
                  textDecoration: "underline",
                }}
                onClick={() => this.goToClinicHistory(row.row.original)}
              >
                {row.value}
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {row.row.original.requerimientos_especiales != undefined &&
                this.state.askSpecialReq ? (
                  <>
                    <div>
                      <p style={{ marginLeft: 3, color: "#1086e0" }}>
                        Req. Especiales:
                      </p>
                    </div>
                    <div
                      className="flex-row"
                      style={{ justifyContent: "center", flex: "wrap" }}
                    >
                      {row.row.original.requerimientos_especiales
                        .hospitalizado != undefined &&
                      row.row.original.requerimientos_especiales
                        .hospitalizado != false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faPlusSquare}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.muletas !=
                        undefined &&
                      row.row.original.requerimientos_especiales.muletas !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faCrutch}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.sillas !=
                        undefined &&
                      row.row.original.requerimientos_especiales.sillas !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faWheelchair}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales
                        .sintomas_respiratorios != undefined &&
                      row.row.original.requerimientos_especiales
                        .sintomas_respiratorios != false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faHeadSideCough}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.oxigeno !=
                        undefined &&
                      row.row.original.requerimientos_especiales.oxigeno !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faLungs}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.camilla !=
                        undefined &&
                      row.row.original.requerimientos_especiales.camilla !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faProcedures}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.ambulancia !=
                        undefined &&
                      row.row.original.requerimientos_especiales.ambulancia !=
                        false ? (
                        <div className="element-icon-adm">
                          {" "}
                          <FontAwesomeIcon
                            icon={faAmbulance}
                            style={{ marginLeft: 3, color: "#1086e0" }}
                          />
                        </div>
                      ) : null}
                      {row.row.original.requerimientos_especiales.ninguno !=
                        undefined &&
                      row.row.original.requerimientos_especiales.ninguno !=
                        false &&
                      row.row.original.requerimientos_especiales.otro ==
                        false &&
                      row.row.original.requerimientos_especiales.ambulancia ==
                        false &&
                      row.row.original.requerimientos_especiales.camilla ==
                        false &&
                      row.row.original.requerimientos_especiales.oxigeno ==
                        false &&
                      row.row.original.requerimientos_especiales
                        .sintomas_respiratorios == false &&
                      row.row.original.requerimientos_especiales.sillas ==
                        false &&
                      row.row.original.requerimientos_especiales.muletas ==
                        false &&
                      row.row.original.requerimientos_especiales
                        .hospitalizado == false ? (
                        <div className="element-icon-adm">
                          <span style={{ marginLeft: 3, color: "#1086e0" }}>
                            Ninguno
                          </span>
                        </div>
                      ) : null}
                    </div>
                    {row.row.original.requerimientos_especiales.otro !=
                      undefined &&
                    row.row.original.requerimientos_especiales.otro != false ? (
                      <div className="element-icon-adm">
                        <span style={{ marginLeft: 3, color: "#1086e0" }}>
                          {" "}
                          - {row.row.original.requerimientos_especiales.otroReq}
                        </span>
                      </div>
                    ) : null}
                  </>
                ) : null}
                {this.state.askFallingRisk && (
                  <div
                    className="flex-column "
                    style={{ alignItems: "center" }}
                  >
                    <div>Riesgo de caída: </div>
                    <div>
                      <span>
                        <FontAwesomeIcon
                          icon={faCircle}
                          style={{
                            color: this.verifyColorRisk(
                              row.row.original.riesgo_caidas
                            ),
                          }}
                        />{" "}
                        <b>{row.row.original.riesgo_caidas.riesgo}</b>
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </span>
          ),
        },
        /* {
                    Header: 'Fecha',
                    accessor: 'fecha',
                    Cell: row => (
                        <span className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                            {row.value}
                        </span>)
                }, */
        {
          Header: "FECHA CITA",
          accessor: "fecha_cita",
          Cell: (row) => (
            <div
              className="title-list-admission-group"
              style={{ padding: 0, margin: 0 }}
            >
              <div className="title-list-admission">
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {moment(row.row.original.fecha_cita_agenda).format(
                    "DD-MMM-YYYY"
                  )}
                </span>
              </div>
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {moment(row.row.original.fecha_cita_agenda).format(
                    "h:mm:ss a"
                  )}
                </span>
              </div>
            </div>
          ),
        },
        {
          Header: "FECHA INGRESO",
          accessor: "fecha_ingreso_completa",
          Cell: (row) => (
            <div
              className="title-list-admission-group"
              style={{ padding: 0, margin: 0 }}
            >
              <div className="title-list-admission">
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {moment(
                    row.row.original.fecha_ingreso_completa_admision
                  ).format("DD MMM YYYY")}
                </span>
              </div>
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {moment(
                    row.row.original.fecha_ingreso_completa_admision
                  ).format("h:mm:ss a")}
                </span>
              </div>
            </div>
          ),
        },
        {
          Header: "SERVICIOS",
          accessor: "servName",
          Cell: (row) => (
            <div className="cell-info-table-admission">
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  <b>
                    {row.row.original.profesional != undefined &&
                    row.row.original.profesional != null
                      ? "DR(A). " + row.row.original.profesional.toUpperCase()
                      : ""}
                  </b>
                </span>
              </div>
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  {row.value}
                </span>
                <hr
                  style={{
                    color: "#55e5bb",
                    backgroundColor: "#55e5bb",
                    margin: "0.25em 0.25em",
                    padding: 0,
                  }}
                ></hr>
              </div>
              <div>
                <span
                  className={`admision-new ${
                    row.data[row.row.index].destacar == true
                      ? "effect-admision-new"
                      : null
                  }`}
                >
                  <b>
                    {row.row.original.thirdsName != undefined &&
                    row.row.original.thirdsName != null
                      ? row.row.original.thirdsName
                      : ""}
                  </b>
                </span>
              </div>
            </div>
          ),
        },
      ],
      tableRowsData: this.state.dataTable,
    };
    //console.log(row.row.original)

    return (
      <Card>
        <CardBody>
          <Col>
            <div className="form-clinic-history-list">
              <form className="material-form">
                <div className="form-clinic-history-fields">
                  <div className="legend">Buscar por:</div>
                  <Row>
                    <Col md={3} sm={6} xs={12}>
                      <TextField
                        className="material-form__field"
                        label="Tipo  de documento"
                        id="id-simpledoc-select"
                        select
                        defaultValue={null}
                        value={this.state.typeOfDocument}
                        onChange={(event) => {
                          console.log(event);
                          this.handlerTypeOfDocument(event.target.value);
                        }}
                      >
                        <MenuItem
                          className="material-form__option"
                          key={1}
                          value={"TI"}
                        >
                          TI-Tarjeta de Identidad
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={2}
                          value={"CC"}
                        >
                          CC-Cedula de Ciudadania
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={3}
                          value={"PA"}
                        >
                          PA-Pasaporte
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={4}
                          value={"RC"}
                        >
                          RC-Registro Civil
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={5}
                          value={"CE"}
                        >
                          CE-Cedula de Extranjeria
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={6}
                          value={"MS"}
                        >
                          MS-Menor sin Identificación
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={7}
                          value={"AS"}
                        >
                          AS-Adulto sin Identificación
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={8}
                          value={"SC"}
                        >
                          SC-Salvo Conducto
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={9}
                          value={"CD"}
                        >
                          CD-Carnet Diplomatico
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={10}
                          value={"CN"}
                        >
                          CN-Certificado de Nacido Vivo
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={11}
                          value={"NI"}
                        >
                          NI-Número Identificación Tributario NIT
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={12}
                          value={"PE"}
                        >
                          PE-Permiso Especial de Permanencia
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={13}
                          value={"PT"}
                        >
                          PT-Permiso por Protección Temporal
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={14}
                          value={"SI"}
                        >
                          SI-Sin Identificación
                        </MenuItem>
                      </TextField>
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <TextField
                        required
                        className="material-form__field"
                        id="document-standard-required"
                        label="Documento"
                        type="number"
                        value={this.state.id}
                        onChange={(e) => {
                          this.handlerDocumentNumber(e.target.value);
                        }}
                        //disabled={(this.state.history !== "" && this.state.history !== null) || this.state.names !== "" || this.state.firstLastName !== "" || this.state.secondLastName !== ""}
                      />
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <TextField
                        required
                        className="material-form__field"
                        id="first-name-standard-required"
                        label="Nombres"
                        type="text"
                        value={this.state.names}
                        onChange={(e) => {
                          this.handlerNames(e.target.value);
                        }}
                      />
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <TextField
                        required
                        className="material-form__field"
                        id="first-last-name-standard-required"
                        label="Primer apellido"
                        type="text"
                        value={this.state.firstLastName}
                        onChange={(e) => {
                          this.handlerFirstLastName(e.target.value);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3} sm={6} xs={12}>
                      <TextField
                        required
                        className="material-form__field"
                        id="second-last-name-standard-required"
                        label="Segundo apellido"
                        type="text"
                        value={this.state.secondLastName}
                        onChange={(e) => {
                          this.handlerSecondLastName(e.target.value);
                        }}
                      />
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <ThemeProvider theme={defaultMaterialTheme}>
                          <KeyboardDatePicker
                            variant="inline"
                            label="Fecha"
                            className="material-form__field"
                            value={this.state.date}
                            onChange={(date) => {
                              this.handlerDate(date);
                            }}
                            format="DD/MM/YYYY"
                            animateYearScrolling
                            InputLabelProps={{
                              shrink: true,
                            }}
                            //disabled={(this.state.history !== "" && this.state.history !== null) || this.state.names !== "" || this.state.firstLastName !== "" || this.state.secondLastName !== ""}
                          />
                        </ThemeProvider>
                      </MuiPickersUtilsProvider>
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <TextField
                        className="material-form__field"
                        label="Procedimiento a realizar"
                        id="id-simpledoc-select"
                        select
                        defaultValue={""}
                        value={this.state.serviceText}
                        onChange={(event) => {
                          this.handlerServiceText(event.target.value);
                        }}
                      >
                        <MenuItem
                          className="material-form__option"
                          key={1}
                          value={"GAMAGRAFIA"}
                        >
                          GAMAGRAFIA
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={2}
                          value={"CONSULTA"}
                        >
                          CONSULTA
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={3}
                          value={"CARDIOLOGIA"}
                        >
                          CARDIOLOGIA
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={4}
                          value={"ECOGRAFIA"}
                        >
                          ECOGRAFIA
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={5}
                          value={"RESONANCIA"}
                        >
                          RESONANCIA
                        </MenuItem>
                      </TextField>
                    </Col>
                  </Row>
                </div>
                <div className="form-admission-buttons">
                  {this.state.date && (
                    <div className="form-admission-info-date">
                      <div className="form-admission-buttons-search-date">
                        <ButtonGroupMui
                          variant="text"
                          aria-label="text primary button group"
                        >
                          <ButtonMui
                            className="group-button"
                            onClick={() => {
                              this.goToSelectedDate(
                                this.state.date,
                                false,
                                true
                              );
                            }}
                          >
                            <FontAwesomeIcon
                              className="icon-selected-date"
                              icon={faChevronCircleLeft}
                            />
                          </ButtonMui>
                          <ButtonMui
                            className="group-button"
                            onClick={() => {
                              this.goToSelectedDate(
                                this.state.date,
                                false,
                                false
                              );
                            }}
                          >
                            <FontAwesomeIcon
                              className="icon-selected-date"
                              icon={faCircle}
                            />
                          </ButtonMui>
                          <ButtonMui
                            className="group-button"
                            onClick={() => {
                              this.goToSelectedDate(
                                this.state.date,
                                true,
                                false
                              );
                            }}
                          >
                            <FontAwesomeIcon
                              className="icon-selected-date"
                              icon={faChevronCircleRight}
                            />
                          </ButtonMui>
                        </ButtonGroupMui>
                      </div>
                      <div className="title-date">
                        <h5>
                          {moment(
                            this.state.datetwo !== null
                              ? this.state.datetwo
                              : this.state.date
                          ).format("DD [de] MMMM [de] YYYY")}
                        </h5>
                      </div>
                    </div>
                  )}
                  <div>
                    {this.state.permits.includes(60) ? (
                      <div className="group-reactrap-buttons">
                        <div>
                          <Button
                            style={{ marginRight: 12, marginTop: 20 }}
                            size="sm"
                            color="primary"
                            onClick={() => {
                              this.setState({ indexPage: 0 });
                              this.searchHistorial(false, true, false);
                            }}
                          >
                            <SearchIcon />
                            Buscar
                          </Button>
                        </div>
                        <div>
                          <Button
                            style={{ marginRight: 12, marginTop: 20 }}
                            size="sm"
                            color="primary"
                            onClick={() => {
                              this.setState({ indexPage: 0 });
                              this.searchHistorial(false, true, true);
                            }}
                          >
                            <SearchIcon />
                            Buscar HC de otros Doctores
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <Button
                        style={{ marginRight: 12, marginTop: 20 }}
                        size="sm"
                        color="primary"
                        onClick={() => {
                          this.setState({ indexPage: 0 });
                          this.searchHistorial(false, true, false);
                        }}
                      >
                        <SearchIcon />
                        Buscar
                      </Button>
                    )}
                  </div>
                </div>
              </form>
              <div
                style={{ display: "flex", justifyContent: "flex-end" }}
              ></div>
              <div style={{ marginTop: 10 }}>
                {this.state.isLoading ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="success" />
                  </div>
                ) : (
                  <DataReactTable
                    reactTableData={
                      profile === "10" || this.state.permits.includes(43)
                        ? reactTableDataProfessional
                        : reactTableData
                    }
                    title={""}
                    refreshData={this.refreshData}
                    callbackTenCorrect={this.callbackTenCorrect}
                    callbackFallingRisks={this.callbackFallingRisks}
                    callbackRadioPharmacy={this.callbackRadioPharmacy}
                    callbackupdateCanalization={this.callbackupdateCanalization}
                    callbackActivityPatientStudio={
                      this.callbackActivityPatientStudio
                    }
                    callbackupdateStateClinicHistory={
                      this.callbackupdateStateClinicHistory
                    }
                    callbackupdateStatusPatient={
                      this.callbackupdateStatusPatient
                    }
                    callbackupdateStatusVitalSigns={
                      this.callbackupdateStatusVitalSigns
                    }
                    handlerIndexPage={this.handlerPageIndex}
                    indexPageForm={this.state.indexPage}
                  />
                )}
              </div>
            </div>
          </Col>
        </CardBody>
        {this.state.openModalAlergies &&
        this.state.currentPatientInfo !== null ? (
          <AlergiesListToShow
            id_historia={this.state.currentPatientInfo.id_historia}
            openModaAlergie={this.state.openModalAlergies}
            handlerOpenModalAlergies={this.handlerOpenModalAlergies}
          />
        ) : null}
      </Card>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SearchForm);
